module.exports = {"animatingSpeed":"1.5s","position":"absolute","afterInset":"-2px","beforeInset":"0","afterZIndex":"-2","beforeZIndex":"-1"};